import { config } from './consts';

export const prepareSignUpDate = (date: Record<string, any>) => {
    const clientname = date.email.split('@')[1];

    return {
        realname: `${date.firstname} ${date.lastname}`,
        email: date.email,
        password: date.password,
        language: 'en',
        partner_uuid: config.partnerUUID,
        clientname
    };
};

export const signUp = async (payload: Record<string, any>) => {
    const response = await fetch(`${config.apiURL}/v2/registration`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        referrer: 'https://www.wallarm.com/',
        referrerPolicy: 'strict-origin-when-cross-origin',
        body: JSON.stringify(payload),
        method: 'POST',
        mode: 'cors',
        credentials: 'include'
    });

    const parsedRes = await response.json();
    return { [response.ok ? 'res' : 'err']: parsedRes.body || parsedRes };
};
